import { render, staticRenderFns } from "./YoutubeContent.vue?vue&type=template&id=46e21cc3&scoped=true&"
import script from "./YoutubeContent.vue?vue&type=script&lang=js&"
export * from "./YoutubeContent.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeContent.vue?vue&type=style&index=0&id=46e21cc3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e21cc3",
  null
  
)

export default component.exports